import Tour from 'reactour';

export interface TourSteps {
	selector: string;
	content: string | JSX.Element;
	position?: 'top' | 'right' | 'bottom' | 'left' | 'center';
}
export interface TourProps {
	steps: TourSteps[];
	isOpen: boolean;
	setIsTourOpen: React.Dispatch<React.SetStateAction<boolean>>;
  showBadge?: boolean
}
export default function RenderTour(tourProps: TourProps) {
	const { steps, isOpen, setIsTourOpen, showBadge } = tourProps;
	return (
		<>
			<Tour
				steps={steps}
				isOpen={isOpen}
				onRequestClose={() => setIsTourOpen(false)}
				accentColor="#1890ff"
        rounded={8}
				badgeContent={() => showBadge && <div style={{ fontSize: '0.75rem', color: '#fff' }}>Use → ou ← para navegar</div>}
				getStyles={() => ({
					maskWrapper: {
						backgroundColor: 'rgba(0, 0, 0, 0.2)',
					},
				})}
			/>
		</>
	);
}
